import '../App.css';

import { Container, Button, Navbar, Nav, NavItem, NavDropdown, MenuItem, NavLink, FormControl, Form, Alert } from 'react-bootstrap';

import $ from "jquery";
import React, { useState, Component } from 'react';
import axios from "axios";
import { Sida, Rubrik, Stycke, ContentWrapper, Rubrik_ } from "./ContentStyles";
import ReactPlayer from 'react-player';
import Album from "./Album";
import Rules from './Rules';
import "./Home.scss";
import {
  FaMobileAlt,
  FaStore,
  FaBarcode,
  FaCreditCard,
  FaLock,
} from "react-icons/fa";
import { FaShopLock } from "react-icons/fa6";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { Branding, Helmetx } from '../services/misc';

const shoot = () => {
  alert();
}

const Home = () => {

  return (
    <>
      <Helmetx />
      <ContentWrapper>
        <Container>
          <Sida>
            <section className="hero" aria-labelledby="home-hero-title">
              <div className="hero__bg" />

              <div className="hero__grid">
                <div className="hero__left">
                  {/* <div className="hero__badge"><BsLightning /> Snabbt. Enkelt. Säkert.</div> */}

                  <h1 id="home-hero-title" className="hero__title">
                    Starta din egen <br />
                    <span>24/7 butik</span>
                  </h1>

                  <p className="hero__lead">
                    Låt dina kunder handla dygnet runt i en obemannad butik med vår smarta app. Kunden identifierar sig, låser upp, skannar varor och betalar direkt i mobilen.
                  </p>

                  <div className="hero__actions">
                    {/* <a className="hero__btn hero__btn--primary" href="https://apps.apple.com/se/app/nookshop/id6443705977">
                    Hämta appen
                  </a> */}
                    <a className="hero__btn hero__btn--primary" href="/PricingPage" title="Se priser och abonnemang för obemannad butik">
                      Visa abonnemang
                    </a>
                    <button
                      type="button"
                      className="hero__btn hero__btn--secondary"
                      onClick={() => {
                        document.getElementById("how")?.scrollIntoView({ behavior: "smooth" });
                      }}
                    >
                      Hur handlar man?
                    </button>
                  </div>

                  <div className="hero__stats">
                    <div className="hero__stat">
                      <div className="hero__statValue">24/7</div>
                      <div className="hero__statLabel">Tillgängligt</div>
                    </div>
                    <div className="hero__stat">
                      <div className="hero__statValue">BankID</div>
                      <div className="hero__statLabel">Identifiering</div>
                    </div>
                    <div className="hero__stat">
                      <div className="hero__statValue">Swish</div>
                      <div className="hero__statLabel">Betalning</div>
                    </div>
                  </div>
                </div>

                <div className="hero__right ">
                  <div className="hero__card hero__card--tiltA hero-card rotate-right">
                    <div className="hero__cardHeader">
                      <div className="hero__icon"><FaShopLock /></div>
                      <div>
                        <div className="hero__cardTitle">Exempel på verksamheter</div>
                      </div>
                    </div>

                    <div className="hero__rows">
                      <div className="hero__row hero__row--ok">Sälj ägg eller honung vid vägkanten</div>
                      <div className="hero__row hero__row--info">Öppna en lokal kiosk i byn</div>
                      <div className="hero__row hero__row--warm">Fikaservice på arbetsplatser och skolor</div>
                      <div className="hero__row hero__row--ok">Obemannad service på gym, campingplatser, golfbanor eller vandrarhem</div>
                      <div className="hero__row hero__row--info">Gårdsbutik</div>
                    </div>
                  </div>

                  <div className="hero__card hero__card--tiltB hero__card--orange hero-card rotate-left">
                    <div className="hero__small">Inspiration</div>
                    <div className="hero__offer">Såhär kan din butik se ut</div>
                    <a className="hero__pill" href="/galleri" title="Se exempel på hur en obemannad butik kan se ut">
                      Se galleri
                    </a>
                  </div>

                  <div className="hero__glow" />
                </div>
              </div>
            </section>

            <section className="infoCard" aria-labelledby="about-platform-title">
              <div className="infoCard__inner">
                <div className="infoCard__head">
                  <div className="infoCard__badge">Vad är Närbutik.se</div>
                  <h2 id="about-platform-title" className="infoCard__title">
                    En plattform för obemannad butik och smart självservice
                  </h2>
                </div>



                <p className="infoCard__body">
                  Närbutik.se är en plattform som gör det enkelt att starta en obemannad butik, fikahörna eller gårdsbutik. Vi tror att det bara är fantasin som sätter gränser för hur plattformen kan användas. Med våra låsmoduler kan du enkelt koppla upp en dörr eller ett kylskåp så att kunden bara kan öppna efter identifiering med BankID.
                </p>


                {/* <div className="infoCard__col">
                  <div className="infoCard__sub">Exempel på verksamheter</div>
                  <ul className="infoCard__list">
                    <li>Gårdsbutiker</li>
                    <li>Kioskverksamhet</li>
                    <li>Hotell/Vandrarhem</li>
                    <li>Livsmedelsbutik</li>
                    <li>Golfbanor</li>
                    <li>Arbetsplatser</li>
                    <li>Idrottshallar</li>
                    <li>Föreningar</li>
                    <li>Gym</li>
                  </ul>
                </div> */}

              </div>
            </section>




            <div>


              <div>
                <div>
                  <section id="how" className="how" aria-labelledby="how-title">
                    <div className="how__head">
                      <span className="how__badge">Hur handlar man?</span>
                      <h2 id="how-title" className="how__title">Redo på 6 enkla steg</h2>
                      <p className="how__subtitle">
                        Från app till färdigköpt på några minuter
                      </p>
                    </div>

                    <div className="how__wrap">


                      <div className="how__grid">


                        {/* Step 1 */}
                        <div className="how__card how__card--highlight">
                          <div className="how__num">1</div>

                          <div className="how__icon">
                            <FaMobileAlt />
                          </div>

                          <h3 className="how__cardTitle">Ladda ner appen</h3>

                          <p className="how__cardText">
                            Hämta vår app från App Store eller Google Play
                          </p>

                          <div className="how__stores">
                            <a href="https://apps.apple.com/se/app/nookshop/id6443705977">
                              <img
                                src="https://www.nookshop.se/images/AppStore.png"
                                alt="Ladda ner Nookshop i App Store"
                              />
                            </a>

                            <a href="https://play.google.com/store/apps/details?id=cloudsolution.nookshop">
                              <img
                                src="https://www.nookshop.se/images/GooglePlay.png"
                                alt="Ladda ner Nookshop på Google Play"
                              />
                            </a>
                          </div>
                        </div>


                        {/* Step 2 */}
                        <div className="how__card">
                          <div className="how__num">2</div>
                          <div className="how__icon">
                            <FaStore />
                          </div>
                          <h3 className="how__cardTitle">Lås upp butiken</h3>
                          <p className="how__cardText">
                            Ange butiksid och legitimera dig med BankID
                          </p>
                        </div>

                        {/* Step 3 */}
                        <div className="how__card">
                          <div className="how__num">3</div>
                          <div className="how__icon">
                            <FaBarcode />
                          </div>
                          <h3 className="how__cardTitle">Skanna varorna</h3>
                          <p className="how__cardText">
                            Använd appen för att skanna streckkoden
                          </p>
                        </div>

                        {/* Step 4 */}
                        <div className="how__card">
                          <div className="how__num">4</div>
                          <div className="how__icon">
                            <FaCreditCard />
                          </div>
                          <h3 className="how__cardTitle">Betala enkelt</h3>
                          <p className="how__cardText">
                            Betala snabbt och säkert med Swish, löneavdrag eller autogiro
                          </p>
                        </div>

                        {/* Step 5 */}
                        <div className="how__card">
                          <div className="how__num">5</div>
                          <div className="how__icon">
                            <FaLock />
                          </div>
                          <h3 className="how__cardTitle">Stäng dörren</h3>
                          <p className="how__cardText">
                            Dörren låser sig automatiskt
                          </p>
                        </div>

                        {/* Step 6 */}
                        <div className="how__card how__card--final">
                          <div className="how__num">6</div>
                          <div className="how__icon how__icon--white">
                            <IoMdCheckmarkCircleOutline />
                          </div>
                          <h3 className="how__cardTitle">Du är klar!</h3>
                          <p className="how__cardText">
                            Kvittot skickas till din mejl
                          </p>
                        </div>

                      </div>
                    </div>
                  </section>

                </div>
              </div>



              {/* <div className='' Style="float: right;height: auto; max-width:420px;">
              <ReactPlayer url='handlaiennook.mp4' controls={true} playing={true} muted={true} loop={true} width='100%' height='100%' />
            </div> */}





              <section className="demoSide" aria-labelledby="demo-title">
                <div className="demoSide__frame">
                  <div className="demoSide__decor demoSide__decor--a" aria-hidden="true" />
                  <div className="demoSide__decor demoSide__decor--b" aria-hidden="true" />

                  <div className="demoSide__video">
                    <ReactPlayer
                      url="handlaiennook.mp4"
                      controls={true}
                      playing={true}
                      muted={true}
                      loop={true}
                      width="100%"
                      height="100%"
                    />
                  </div>

                  <div className="demoSide__content">
                    <div className="demoSide__badge">
                      <span className="demoSide__badgeIcon">▶</span>
                      <span>Se hur det fungerar</span>
                    </div>

                    <h2 id="demo-title" className="demoSide__title">
                      Se hur Nookshop fungerar i en obemannad butik
                    </h2>

                    <p className="demoSide__text">
                      Så här enkelt är det att handla i en obemannad butik
                    </p>
                  </div>
                </div>
              </section>
            </div>



            {/* <Rubrik>Bilder</Rubrik>
          <Album /> */}
            {/* <Faq /> */}

          </Sida>
        </Container>

      </ContentWrapper>
    </>
  );
}

export default Home;